export enum EItemType {
  INVENTORYITEM = 'INVENTORYITEM',
  SERVICEITEM = 'SERVICEITEM',
  BOOKABLERESOURCE = 'BOOKABLERESOURCE'
}

export enum EStockStatus {
  INSTOCK = 'INSTOCK',
  OUTOFSTOCK = 'OUTOFSTOCK',
  LOWSTOCK = 'LOWSTOCK'
}

export enum EResourceRates {
  MONTHLY = 'MONTHLY',
  DAILY = 'DAILY',
  HOURLY = 'HOURLY'
}

export interface ITax {
  _id?: string;
  name: string;
  percentage: number;
  amount?: string;
  convertedAmount?: string;
}

export interface IItem {
  _id?: string;
  name?: string;
  itemCategory?: ICategory;
  inStock?: EStockStatus;
  price: number;
  cost: number;
  quantity?: number;
  categoryToAdd?: string;
  trackInventory?: boolean;
  menuItems?: any[];
  sku?: string;
  itemType?: EItemType;
  isTaxed?: boolean;
  reorderLevel?: number;
  taxes?: ITax[];
  image?: any;
  itemImage?: {
    contentType: string;
    data: string;
  };
  top?: any;
  updateQuantity?: boolean;
  description?: string;
}

export interface ICategory {
  _id?: string;
  name: string;
  numberOfItems: number;
  items: any[];
  menuItems?: any[];
}
